module.exports = __webpack_public_path__ + "static/media/assignblue.1d2b48be.svg";